import { createContext, type PropsWithChildren, useContext, useMemo } from 'react';

import { type Country } from '~/vendor/cx-modules/constants';
import { type StateCode } from '~/vendor/cx-modules/types';

export type GeolocationContextData = {
  countryCode: Country;
  state: StateCode | '';
};

export const GeolocationContext = createContext<GeolocationContextData | undefined>(undefined);
GeolocationContext.displayName = 'GeolocationContext';

export const GeolocationProvider = ({ children, countryCode, state }: PropsWithChildren<GeolocationContextData>) => {
  const value = useMemo(() => ({ countryCode, state }), [countryCode, state]);

  return <GeolocationContext.Provider value={value}>{children}</GeolocationContext.Provider>;
};

export const useGeolocationContext = () => {
  const context = useContext(GeolocationContext);
  if (!context) {
    throw new Error('useGeolocationContext can only be used inside of GeolocationProvider');
  }

  return context;
};
